const CLEAR_EPSILON = 0.000001;

function numberValue(value, fallback = 0) {
  const number = Number(value);
  return Number.isFinite(number) ? number : fallback;
}

function attackDamageTotal(entries = []) {
  return (Array.isArray(entries) ? entries : [])
    .reduce((sum, entry) => sum + Math.max(0, numberValue(entry?.damageEok ?? entry?.damage_eok)), 0);
}

export function summarizeRaidStrategyProgress({ reconciliation = {}, targetHpEok = 0 } = {}) {
  const target = Math.max(0, numberValue(targetHpEok));
  const actualEntries = Array.isArray(reconciliation?.actualEntries) ? reconciliation.actualEntries : [];
  const unmatchedActuals = Array.isArray(reconciliation?.unmatchedActuals) ? reconciliation.unmatchedActuals : [];
  const unmatchedPlans = Array.isArray(reconciliation?.unmatchedPlans) ? reconciliation.unmatchedPlans : [];
  const actualDamageEok = attackDamageTotal(actualEntries);
  const targetReached = target > CLEAR_EPSILON && actualDamageEok + CLEAR_EPSILON >= target;
  const activePlans = targetReached ? [] : unmatchedPlans;
  const excludedPlans = targetReached ? unmatchedPlans : [];
  const plannedDamageEok = attackDamageTotal(activePlans);
  const projectedTotalEok = actualDamageEok + plannedDamageEok;
  const remainingAfterActualEok = Math.max(0, target - actualDamageEok);
  const remainingAfterPlanEok = Math.max(0, target - projectedTotalEok);
  const needsPlanReview = !targetReached && unmatchedActuals.length > 0 && activePlans.length > 0;

  return {
    targetHpEok: target,
    actualEntries,
    unmatchedActuals,
    unmatchedPlans,
    activePlans,
    excludedPlans,
    actualDamageEok,
    plannedDamageEok,
    projectedTotalEok,
    remainingAfterActualEok,
    remainingAfterPlanEok,
    targetReached,
    needsPlanReview,
    hasWarning: needsPlanReview || excludedPlans.length > 0,
  };
}

export function plansWithoutCompletedTargets({ plans = [], actualRecords = [], reconcile }) {
  if (typeof reconcile !== 'function') return Array.isArray(plans) ? plans : [];
  return (Array.isArray(plans) ? plans : []).map((plan) => {
    const bossNo = numberValue(plan?.bossNo ?? plan?.boss_no);
    const phaseNo = numberValue(plan?.phaseNo ?? plan?.phase_no);
    const actuals = (Array.isArray(actualRecords) ? actualRecords : []).filter((record) => (
      numberValue(record?.bossNo ?? record?.boss_no) === bossNo
      && numberValue(record?.phaseNo ?? record?.phase_no) === phaseNo
    ));
    const progress = summarizeRaidStrategyProgress({
      reconciliation: reconcile({ plans: [plan], actualRecords: actuals }),
      targetHpEok: plan?.targetHpEok ?? plan?.target_hp_eok,
    });
    return progress.targetReached && Array.isArray(plan?.items) && plan.items.length
      ? { ...plan, items: [] }
      : plan;
  });
}
